module.exports = __webpack_public_path__ + "static/media/info.868b9413.svg";